import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {DataSetPref} from '../constants';

/** Is datamanager enabled */
export const datamanagerEnabled = () =>
	getPreference(DataSetPref.ENABLED, true);
